"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = exports.DirectInsertPortfolioCovenantConfigSchema = void 0;
const v4_1 = require("zod/v4");
// every node must export UIConfig.
// this type describes the configuration
// for the node as seen on tape-builder UI.
// there must also be a json schema associated with it.
exports.DirectInsertPortfolioCovenantConfigSchema = v4_1.z.object({
    portfolioCovenantKey: v4_1.z.string().describe('Portfolio covenant key'),
});
exports.UIConfigSchema = v4_1.z
    .object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: v4_1.z.string().describe('Credit facility slug'),
})
    .merge(exports.DirectInsertPortfolioCovenantConfigSchema);
exports.nodeType = 'file_directInsertPortfolioCovenant';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    creditFacilitySlug: true,
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'directInsertPortfolioCovenant';
//# sourceMappingURL=types.js.map